module.exports = __webpack_public_path__ + "img/03_02sozai.fa023727.png";